export default __webpack_public_path__ + "static/media/g-4.cb6b95f2.jpg";